<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-main>
      <el-container style="height: 100%">
        <el-aside width="35rem" class="panel_aside">
          <el-container style="height: 100%">
            <el-header
              class="panel-header"
              style="text-align: left; padding: 4px 4px; height: 42px"
            >
              <div class="panel-tabs">
                <el-tabs
                  class="custom-tabs"
                  v-model="activeName"
                  @tab-click="handleClick"
                >
                  <el-tab-pane label="区域列表" name="first"></el-tab-pane>
                </el-tabs>
              </div>
              <div class="zj-button-bar">
                <el-button
                  class="panel-header-button-left"
                  @click="regionCheckAll"
                  size="small"
                  >全选</el-button
                >
                <el-button
                  class="panel-header-button-right"
                  @click="regionInverse"
                  size="small"
                  >反选</el-button
                >
              </div>
            </el-header>
            <el-divider style="top: -18px"></el-divider>
            <el-main>
              <el-tree
                show-checkbox
                ref="regionTree"
                style="height: 100%"
                :data="EqRegionArr"
                node-key="RegionId"
                :props="defaultProps"
                :default-expanded-keys="expandedKeys"
                default-expand-all="true"
                @check-change="handleCheckChange"
              >
                <span class="custom-tree-node" slot-scope="{ node }">
                  <span class="custom-tree-node-label">
                    {{ node.label }}<i class="el-icon-my-broadcast_e"></i
                  ></span>
                </span>
              </el-tree>
            </el-main>
          </el-container>
        </el-aside>
        <el-main class="main-content">
          <!-- <el-divider style="top: -18px"></el-divider> -->
          <el-header
            class="panel-header"
            style="text-align: left; padding: 4px 4px; height: 42px"
          >
            <div class="panel-tabs">
              <el-tabs
                class="custom-tabs"
                v-model="activeName"
                @tab-click="handleClick"
              >
                <el-tab-pane label="设备列表" name="first"></el-tab-pane>
              </el-tabs>
            </div>
            <div class="zj-button-bar">
              <el-button
                class="panel-header-button-left"
                size="small"
                :disabled="refreshDisabled"
                @click="refreshStatus"
                >刷新</el-button
              >
            </div>
          </el-header>
          <el-divider style="top: -18px"></el-divider>
          <div style="margin-top: 3rem">
            <el-row>
              <el-col :span="8" v-for="(item, index) in Devices" :key="index">
                <el-tooltip placement="top-start" width="250" trigger="hover">
                  <div slot="content">
                    <span v-if="item.TaskName == null || item.TaskName == ''">
                      {{ item.DeviceName + "—音量:" + item.Volume }}</span
                    >
                    <span v-else>
                      {{
                        item.DeviceName +
                        "—" +
                        item.TaskName +
                        "—音量:" +
                        (item.TaskVolume > 0 ? item.TaskVolume : item.Volume)
                      }}</span
                    >
                  </div>
                  <div
                    class="main-content-card"
                    @click="deviceClick(item, index)"
                    :class="
                      item.checked && item.IsEnabled
                        ? 'main-card-checked'
                        : item.IsEnabled
                        ? ''
                        : 'main-card-disabled'
                    "
                  >
                    <!-- <div
                    :class="item.checked ? 'card-close el-icon-close' : ''"
                  ></div> -->
                    <div class="card-device">
                      <i
                        :class="
                          item.IsOnline
                            ? 'el-icon-my-broadcast_e'
                            : 'el-icon-my-broadcast_u'
                        "
                      ></i
                      >&nbsp;&nbsp;{{ item.DeviceName }}
                    </div>
                    <canvas
                      :id="`canvas${item.Id}`"
                      class="canvas"
                      width="350"
                      height="60"
                    ></canvas>
                  </div> </el-tooltip
              ></el-col>
            </el-row>
          </div>
        </el-main>
        <el-aside width="40rem" class="panel_aside">
          <el-container style="height: 100%">
            <el-header
              class="panel-header"
              style="text-align: left; padding: 4px 4px; height: 42px"
            >
              <div class="panel-tabs">
                <el-tabs
                  class="custom-tabs"
                  v-model="activeName"
                  @tab-click="handleClick"
                >
                  <el-tab-pane label="操控面板" name="first"></el-tab-pane>
                </el-tabs>
              </div>
            </el-header>
            <el-divider style="top: -18px"></el-divider>
            <div class="panel-right">
              <div>
                <p class="panel-right-font">文字广播</p>
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="content"
                  @blur="contentChanged"
                ></el-input>
                <div class="panel-right-mode">
                  <span class="panel-right-speed">语速</span>
                  <el-select v-model="speed" style="width: 23%">
                    <el-option
                      v-for="item in speedOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <span class="panel-right-times">循环</span>
                  <el-input v-model="times" style="width: 23%"> </el-input>
                  <span style="margin-left: 2px">次</span>
                </div>
                <div style="margin-top: 10px">
                  <el-button
                    icon="el-icon-my-play"
                    @click="startTTS"
                    :disabled="!playTextIsEnabled"
                    >文字广播</el-button
                  >
                  <el-button
                    icon="el-icon-my-pause"
                    @click="stopTTS"
                    :disabled="!stopTextIsEnabled"
                    >停止广播</el-button
                  >
                </div>
              </div>
            </div>
            <el-header
              class="panel-header"
              style="
                text-align: left;
                padding: 4px 4px;
                height: 42px;
                margin-top: 20px;
              "
            >
              <div class="panel-tabs">
                <el-tabs
                  class="custom-tabs"
                  v-model="activeName"
                  @tab-click="handleClick"
                >
                  <el-tab-pane label="音乐广播" name="first"></el-tab-pane>
                </el-tabs>
              </div>
              <div class="zj-button-bar">
                <el-button
                  class="panel-header-button-left"
                  @click="toggleAllSelection"
                  size="small"
                  >全选</el-button
                >
                <el-button
                  class="panel-header-button-right"
                  @click="toggleInverseSelection(audioList)"
                  size="small"
                  >反选</el-button
                >
                <el-upload
                  style="float: right; margin-left: 1rem"
                  :http-request="httpRequest"
                  :data="uploadData"
                  list-type="picture"
                  accept=".mp3"
                  :show-file-list="false"
                  :file-list="fileList"
                  :before-upload="beforeupload"
                  :on-success="uploadsuccess"
                  :on-progress="uploadProgress"
                  :on-error="uploadError"
                >
                  <el-button
                    class="panel-header-button-left"
                    @click="upload"
                    size="small"
                    >上传</el-button
                  >
                </el-upload>
              </div>
            </el-header>
            <el-divider style="top: -18px"></el-divider>
            <div>
              <zj-layout-main style="padding: 0.8rem 0px 0px 0px">
                <el-table
                  class="table-music"
                  :data="audioList"
                  ref="multipleTable"
                  border
                  style="width: 100%"
                  height="200"
                  :element-loading-text="loadingAudioText"
                  v-loading="loadingAudio"
                  :show-header="false"
                  :cell-style="selectionStyle"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    type="selection"
                    width="25"
                    align="right"
                  ></el-table-column>
                  <el-table-column align="left">
                    <template slot-scope="scope">
                      <div>
                        <span>{{ scope.row.FileName }}</span>
                      </div>
                      <div>
                        <el-button
                          @click="moveupClick(scope.row)"
                          type="text"
                          size="small"
                          :disabled="scope.$index == 0 || IsEdit"
                          >上移</el-button
                        >
                        <el-button
                          @click="movedownClick(scope.row)"
                          type="text"
                          size="small"
                          :disabled="IsEdit"
                          >下移</el-button
                        >
                        <el-button
                          @click="downloadClick(scope.row)"
                          type="text"
                          size="small"
                          :disabled="IsEdit"
                          >下载</el-button
                        >
                        <el-button
                          @click="deleteClick(scope.$index, scope.row)"
                          type="text"
                          size="small"
                          v-if="!IsEdit"
                          >删除</el-button
                        >
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </zj-layout-main>
            </div>
            <div class="panel-right-mode">
              <el-select
                v-model="playMode"
                style="width: 35%"
                @change="handleModeChange"
              >
                <el-option
                  v-for="item in playModeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div style="margin-top: 10px">
              <el-button
                icon="el-icon-my-play"
                :disabled="!playMP3IsEnabled"
                @click="startMP3"
                >音乐广播</el-button
              >
              <el-button
                icon="el-icon-my-pause"
                :disabled="!stopMP3IsEnabled"
                @click="stopMP3"
                >停止广播</el-button
              >
            </div>
            <el-header
              class="panel-header"
              style="
                text-align: left;
                padding: 4px 4px;
                height: 42px;
                margin-top: 20px;
              "
            >
              <div class="panel-tabs">
                <el-tabs
                  class="custom-tabs"
                  v-model="activeName"
                  @tab-click="handleClick"
                >
                  <el-tab-pane label="人工广播" name="first"></el-tab-pane>
                </el-tabs>
              </div>
            </el-header>
            <el-divider style="top: -18px"></el-divider>
            <div style="margin-top: 10px">
              <el-button
                icon="el-icon-my-play"
                @click="startMIC0"
                :disabled="!playMIC0IsEnabled"
                >人工广播</el-button
              >
              <el-button icon="el-icon-my-pause" :disabled="!stopMIC0IsEnabled"
                >停止广播</el-button
              >
            </div>

            <div class="vulume_adjust">
              <p class="panel-right-font">音量调节</p>
              <el-slider
                v-model="volume"
                :disabled="!volumeSliderIsEnabled"
                @change="SetVolume"
              ></el-slider>
            </div>
          </el-container>
        </el-aside>
      </el-container>
    </zj-layout-main>
    <el-dialog
      title="请选择寻呼台..."
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      :append-to-body="true"
      style="text-align: left"
      :destroy-on-close="true"
      ><MICInfo
        :MICArray="mics"
        @clickCancel="clickCancel"
        @clickConfirm="clickConfirm"
      ></MICInfo>
    </el-dialog>
  </zj-layout-container>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
import Apis from "../../../../../../api";
import utils from "../../../../../../utils";
import MICInfo from "./MICInfo";
const ZJPlayer = ZJApp.ZJPlayer;
const MediaCenter = ZJPlayer.MediaCenter;
const MSG = ZJPlayer.MediaCenterMsg;
export default {
  name: "ControlPanelHttpView",
  controller: "UI",
  action: "ControlPanelHttpView",
  components: { MICInfo },
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      deviceName: null,
      RegionId: null,
      EqRegionArr: [],
      DeviceList: [],
      Devices: [],
      defaultProps: {
        children: "",
        label: "RegionName",
      },
      expandedKeys: [],
      loading: false,
      loadingText: "",
      loadingTreeText: "",
      loadingAudioText: "",
      loadingAudio: false,
      activeName: "first",
      flag: false, // 属性是否选中标识
      content: "",
      voice: "",
      speed: 4,
      times: 1,
      volume: 0,
      speedOptions: [
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
        {
          value: 4,
          label: "4",
        },
        {
          value: 5,
          label: "5",
        },
        {
          value: 6,
          label: "6",
        },
        {
          value: 7,
          label: "7",
        },
        {
          value: 8,
          label: "8",
        },
        {
          value: 9,
          label: "9",
        },
        {
          value: 10,
          label: "10",
        },
      ],
      playMode: 0,
      playModeOptions: [
        {
          value: 0,
          label: "顺序播放",
        },
        {
          value: 1,
          label: "循环播放",
        },
        {
          value: 2,
          label: "随机播放",
        },
      ],
      uploadData: {
        module: "Broadcast", //模块名
        submodule: "Music", //子模块
        assocID: "", //业务ID
        uploader: ZJApp.ZJUser.current.UserName, //上传人
        folder: "/Broadcast/AudioFiles", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0, //扩展字段 3
      },
      fileList: [],
      selectionRows: [],
      Playlist: [],
      PlayListItem: [{ Items: [] }],
      audioList: [],
      PlaylistId: "365aad61-0005-4797-98c3-6d06398d75c0",
      result: false,
      serverConfig: [],
      TASK_NAME_MIC0: "单向广播",
      TASK_NAME_TEXT: "文字广播",
      TASK_NAME_MP3: "音乐广播",
      endpoints: [],
      selectDevices: [],
      tempTaskId: null,
      tempMIC0TaskId: null,
      tempMP3TaskId: null,
      refreshIsEnabled: false, //刷新按钮禁用状态
      playMP3IsEnabled: false, //MP3按钮禁用状态
      stopMP3IsEnabled: false, //停止
      playTextIsEnabled: false, //文字
      stopTextIsEnabled: false, //文字
      playMIC0IsEnabled: false, //麦克风
      stopMIC0IsEnabled: false, //麦克风
      volumeSliderIsEnabled: false, //音量
      deviceFlag: false,
      mics: [],
      dialogVisible: false,
      TextItem: null,
      msgRes: null,
    };
  },
  created: function () {
    this.mc = new MediaCenter({
      address:this.CNF('mediaCenter.extend.broadcast')
    });
    this.mc.on("connected", () => this.onConnected());
    this.mc.on("msg", (e) => this.onRecv(e));
    this.mc.on("error", (e) => this.onError(e));
    this.handleLoad();
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  mounted: function () {
    this.init();
    // setTimeout(() => {
    //   this.init();
    // }, 1000);
  },

  methods: {
    //1、获取终端信息
    //2、获取广播设备信息
    //3、根据收到的终端消息，来更新设备信息（将终端信息合到设备信息上（前端操作数据））。
    //4、列表不展示配置的排除的设备信息，
    //初始化时同步设备
    init() {
      this.loading = true;
      //所属区域
      const that = this;
      utils
        .waitAll([
          () => that.getRegionInfo(),
          () => that.getEquipments(),
          that.config.getUValue("BroadcastSubSystem:BroadcastServer:", ""),
        ])
        .then((r) => {
          that.EqRegionArr = r[0].data.Data;
          that.DeviceList = r[1].data.Data;
          that.serverConfig = r[2].JValue;

          //绑定设备状态
          that.BindDeviceStatus();
          //排除设备
          const ExclusionEquip =
            that.serverConfig.filter((item) => {
              return item.ItemKey == "BroadcastServerExclusion";
            }) || [];
          const Exclusions = (ExclusionEquip[0].ItemValue || "").split(",");
          let mapE = {};
          Exclusions.forEach((element) => {
            mapE[element] = element;
          });
          that.Devices = [];
          that.DeviceList.forEach((item) => {
            if (!mapE[item.DeviceId]) {
              that.Devices.push(item);
            }
          });
          that.UpdateButtonState();
          // setTimeout(() => {
          //   that.UpdateButtonState();
          // }, 300);

          that.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });

     // this.findPlayList();
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    //音乐广播列表样式
    selectionStyle({ columnIndex }) {
      if (columnIndex === 0) {
        return `padding:7px 0 40px 8px;`;
      } else {
        return "";
      }
    },
    //区域列表
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      return new MyApis.RegionList().GetRegionInfos(RegionInfo);
    },
    convertToTreeNodes(list, regions) {
      //不改变原数组
      let result = JSON.parse(JSON.stringify(regions));

      for (let i = 0; i < list.length; i++) {
        var deviceData = list[i];
        var device = {
          id: deviceData.DeviceId,
          label: deviceData.DeviceName,
          pid: deviceData.RegionId,
          type: "Device",
          children: [],
        };
        for (let j = 0; j < result.length; j++) {
          if (result[j].id == deviceData.RegionId) {
            result[j].children.push(device);
          }
        }
      }

      return result;
    },
    //区域列表全选
    regionCheckAll() {
      this.flag = true;
      this.$refs.regionTree.setCheckedNodes(this.EqRegionArr);
    },
    //区域列表反选
    regionBatchSelect(nodes, refs, flag, seleteds) {
      if (typeof nodes != "undefined") {
        nodes.forEach((element) => {
          refs.setChecked(element, flag, true);
        });
      }

      if (typeof seleteds != "undefined") {
        seleteds.forEach((node) => {
          refs.setChecked(node, !flag, true);
        });
      }
    },
    // 反选
    regionInverse() {
      let res = this.$refs.regionTree;
      let nodes = res.getCheckedNodes(true, true);
      this.regionBatchSelect(this.EqRegionArr, res, true, nodes);
    },
    //区域树选择更新设备列表状态
    handleCheckChange(data, checked) {
      //如果是设备列表点击触发区域树选择状态，return,防止选择全部
      if (this.deviceFlag) {
        this.deviceFlag = false;
        return;
      }
      const that = this;

      that.Devices.forEach((device, index) => {
        if (
          device != null &&
          device.IsEnabled &&
          device.RegionId == data.RegionId
        ) {
          device.checked = checked;
          that.$set(that.Devices, index, device);
          //添加、移除选中设备
          if (checked) {
            that.selectDevices.push(device);
            this.UpdateVolumeSlider();
          } else {
            device.checked = !checked;
            const delIndex = that.selectDevices.indexOf(device);
            if (delIndex > -1) {
              that.selectDevices.splice(delIndex, 1);
            }
            device.checked = checked;
          }
        }
      });

      that.UpdateButtonState();
    },
    //获取设备列表
    getEquipments() {
      return new MyApis.TranResourcesApi().GetEquipmentMangeList({
        EquipmentType: "Broadcast",
      });
    },
    //绑定设备状态
    BindDeviceStatus() {
      if (this.endpoints.length == 0 || this.DeviceList.length == 0) return;
      let mapP = {};
      this.endpoints.forEach((element) => {
        mapP[element.Id] = element;
      });
      this.DeviceList.forEach((dev) => {
        let ep = null;
        if (!mapP[dev.DeviceId]) {
          ep = null;
        } else {
          ep = mapP[dev.DeviceId];
        }
        this.UpdateDeviceInfo(dev, ep);
      });
    },
    //根据收到的终端消息，来更新设备信息。
    UpdateDeviceInfo(dest, src) {
      if (dest == null) return;
      if (src == null) {
        dest.TaskId = null;
        dest.TaskName = null;
        dest.TaskVolume = null;
        dest.State = -1; //故障
        dest.IsOnline = false;
        dest.IsEnabled = false;
        return;
      }
      dest.DeviceName = src.Name;
      dest.IsOnline = src.Online == 1;
      dest.TaskId = src.TaskId;
      dest.TaskName = src.TaskName;
      dest.TaskMessage = null;
      dest.Volume = src.Volume || 0;
      if (!dest.IsOnline) dest.State = -1;
      //故障
      else if (src.TaskId != null && src.TaskId != "") dest.State = 1;
      //占用
      //占用
      else dest.State = 0; //空闲
      dest.IsEnabled = dest.IsOnline;
      //  dest.checked = false;
    },
    UpdateDeviceInfoByEP(src) {
      var dest = this.Devices.filter((x) => x.DeviceId == src.Id);
      if (dest.length > 0) {
        this.UpdateDeviceInfo(dest[0], src);
      }
    },
    //根据收到的任务消息，来更新设备信息。
    UpdateDeviceInfoByTask(src) {
      const that = this;
      if (
        src == null ||
        src.TaskEndpointGroup == null ||
        src.TaskEndpointGroup.Length == 0
      )
        return;
      src.TaskEndpointGroup.forEach((ep) => {
        var dests = that.Devices.filter((x) => x.DeviceId == ep.Id);
        if (dests.length > 0) {
          var dest = dests[0];
          dest.TaskId = src.TaskId;
          dest.TaskName = src.TaskName;
          dest.TaskVolume = src.TaskVolume;
          dest.TaskType = src.TaskType;
          dest.TaskMessage = null;

          if (dest.TaskVolume <= 0) dest.TaskVolume = ep.Volume || 0;

          switch (ep.Status) {
            case 1:
              dest.IsOnline = true;
              if (dest.TaskName != null && src.TaskId != "")
                dest.TaskMessage = `"${ep.Name}开始${dest.TaskName}"`;
              break;
            case 2:
              dest.IsOnline = false;
              break;
            case 3:
              dest.IsOnline = true;
              if (dest.TaskName != null && src.TaskId != "")
                dest.TaskMessage = `"${ep.Name}被占用"`;
              break;
          }

          if (!dest.IsOnline) dest.State = -1;
          //故障
          else if (src.TaskId != "" && src.TaskId != null) dest.State = 1;
          //占用
          else dest.State = 0; //空闲
        }
      });
    },
    UpdateButtonState() {
      const that = this;

      var devices = that.Devices.filter((x) => x.checked);

      that.refreshIsEnabled = that.endpoints.length > 0;
      that.playTextIsEnabled =
        that.endpoints.length > 0 &&
        devices.length >
          0 /* &&
                        !devices.Any(x => !string.IsNullOrEmpty(x.TaskId))*/;
      that.stopTextIsEnabled =
        that.endpoints.length > 0 &&
        devices.length > 0 &&
        devices.some((x) => x.TaskName == that.TASK_NAME_TEXT);
      that.playMP3IsEnabled =
        that.endpoints.length > 0 &&
        devices.length >
          0 /* &&
                        !devices.Any(x => !string.IsNullOrEmpty(x.TaskId))*/;
      that.stopMP3IsEnabled =
        that.endpoints.length > 0 &&
        devices.length > 0 &&
        devices.some((x) => x.TaskName == that.TASK_NAME_MP3);
      that.playMIC0IsEnabled =
        that.endpoints.length > 0 &&
        devices.length >
          0 /* &&
                        !devices.Any(x => !string.IsNullOrEmpty(x.TaskId))*/;
      that.stopMIC0IsEnabled =
        that.endpoints.length > 0 &&
        devices.length > 0 &&
        devices.some((x) => x.TaskName == that.TASK_NAME_MIC0);
      that.volumeSliderIsEnabled =
        that.endpoints.length > 0 && devices.length > 0;
    },
    UpdateVolumeSlider() {
      let volume = 0;

      var selectedDevices = this.Devices.filter((x) => x.checked);
      if (selectedDevices.length == 0) {
        volume = 0;
      } else {
        // 选中设备中有播放任务，则仅显示最大任务音量，否则显示最大设备音量。
        if (selectedDevices.some((x) => x.TaskId != null && x.TaskId != "")) {
          var sd = selectedDevices.filter(
            (x) => x.TaskId != null && x.TaskId != ""
          );
          volume = Math.max.apply(
            Math,
            sd.map((item) => {
              return item.TaskVolume > 0 ? item.TaskVolume : item.Volume;
            })
          );
        } else {
          volume = Math.max.apply(
            Math,
            selectedDevices.map((item) => {
              return item.Volume;
            })
          );
        }
      }
      this.volume = volume;
    },
    // 绑定设备状态
    deviceClick(item, index) {
      const delIndex = this.selectDevices.indexOf(item);
      item.checked = !item.checked;
      this.$set(this.Devices, index, item);
      let haveCheckedItem = false; //是否有勾选的项
      let haveUnCheckItem = false; //是否有未勾选的项
      let isChecked = false;
      for (let i = 0; i < this.Devices.length; i++) {
        if (
          this.Devices[i] != null &&
          this.Devices[i].IsEnabled &&
          this.Devices[i].RegionId == item.RegionId
        ) {
          if (this.Devices[i].checked) haveCheckedItem = true;
          else haveUnCheckItem = true;
          if (haveUnCheckItem && haveCheckedItem) break;
        }
      }
      if (haveUnCheckItem && haveCheckedItem)
        //既有勾选的项，也有未勾选的项。
        isChecked = true;
      else if (haveUnCheckItem)
        //全部都未勾选
        isChecked = false;
      else if (haveCheckedItem)
        //全部都勾选
        isChecked = true;
      //不应进入此分支
      else isChecked = false;
      this.$refs.regionTree.setChecked(item.RegionId, isChecked);
      if (item.checked) {
        // this.deviceFlag = true;
        this.UpdateButtonState();
        this.UpdateVolumeSlider();
        this.selectDevices.push(item);
      }
      if (delIndex > -1) {
        this.selectDevices.splice(delIndex, 1);
      }
      this.deviceFlag = true;
    },

    findPlayList() {
      const searchInfo = {
        PageIndex: 1,
        PageSize: 1,
        Filter: {
          Guid: this.PlaylistId,
        },
      };
      new MyApis.PlayList()
        .FindPlaylist(searchInfo)
        .then((r) => {
          r = r.data.Data.Result;
          this.Playlist = r;
          if (this.Playlist.length > 0) {
            const searchItemInfo = {
              PageIndex: 1,
              PageSize: 100000,
              Filter: {
                PlaylistId: this.PlaylistId,
              },
            };
            new MyApis.PlayList()
              .FindPlaylistItem(searchItemInfo)
              .then((r) => {
                r = r.data.Data.Result;
                var playlist = [];
                (r || []).forEach(function(item){
                  if(item.Validity == 1){
                    playlist.push(item);
                  }
                });
                this.Playlist[0].Items = playlist;

                this.BindPlaylist();
              })
              .catch((e) => {
                console.log(e);
                this.$message({ type:"error", message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！"});
              });
          } else {
            const addPlayListInfo = {
              Filter: {
                PlaylistId: this.PlaylistId,
                PlaylistName: "全局播放列表",
                ConditionNum: 0,
                ConditionDate: new Date(),
                Creater: ZJApp.ZJUser.current.UserName,
                CreateTime: new Date(),
                Modifier: ZJApp.ZJUser.current.UserName,
                ModifyTime: new Date(),
                Validity: 1, //新增编辑是1，删除是0
              },
            };
            new MyApis.PlayList()
              .AddPlaylist(addPlayListInfo)
              .then((r) => {
                r = r.data.Result;
                this.PlayListItem = r;
              })
              .catch((e) => {
                console.log(e);
                this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
              });
          }
          // this.BindPlaylist();
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    BindPlaylist() {
      let textItem = null;
      let audios = [];
      for (
        let i = 0, j = 0, len = this.Playlist[0].Items.length;
        i < len;
        i++
      ) {
        var item = this.Playlist[0].Items[i];
        if (item.ItemType == 2) {
          item.CanDelete = true;
          item.CanMoveUp = j > 0;
          item.CanMoveDown = j + 1 < len;
          j++;
          audios.push(item);
        } else {
          textItem = item;
        }
      }

      this.TextItem = textItem;
      this.content =
        textItem.JsonExtend == null || textItem.JsonExtend == ""
          ? ""
          : JSON.parse(textItem.JsonExtend).TextContent;
      this.audioList = audios.sort((x) => x.Sequence);

      this.getFileList();
    },
    BindPlaylistAgain(playlist) {
      if (playlist == null || playlist.Items == null) {
        this.content = "";
        this.audioList = [];
        return;
      }

      let textItem = null;
      let audios = [];
      for (let i = 0, j = 0, len = playlist.Items.length; i < len; i++) {
        var item = playlist.Items[i];
        if (item.ItemType == 2) {
          item.CanDelete = true;
          item.CanMoveUp = j > 0;
          item.CanMoveDown = j + 1 < len;
          j++;
          audios.push(item);
        } else {
          textItem = item;
        }
      }
      this.TextItem = textItem;
      this.content = JSON.parse(textItem.JsonExtend).TextContent;
      this.audioList = audios.sort((x) => x.Sequence);

      this.getFileList();
    },
    errmsg:function(message){
      this.$message({
        type:"error",
        message:message
      });
    },
    // change(){
    //   alert(11);
    // },
    //上传音乐
    beforeupload: function () {
      this.uploadData.assocID = this.PlaylistId;
      this.loadingAudio = true;
      this.loadingAudioText = "上传中... 0%";
    },
    //文字广播文本框失去焦点时，保存数据
    contentChanged() {
      if (this.Playlist == null || this.Playlist.length == 0) return;
      if (this.TextItem == null) {
        const textItem = {
          ItemId: ZJApp.ZJUtils.uuid(),
          PlaylistId: this.PlaylistId,
          ItemType: 1,
          Creater: ZJApp.ZJUser.current.UserName,
          Modifier: ZJApp.ZJUser.current.UserName,
          OpStatus: 1,
        };
        this.Playlist[0].Items.push(textItem);

        this.TextItem = textItem;
      }

      if (
        this.content !=
        (this.TextItem.JsonExtend == ""
          ? ""
          : JSON.parse(this.TextItem.JsonExtend).TextContent)
      ) {
        this.TextItem.JsonExtend = JSON.stringify({
          TextContent: this.content,
          IsChecked: true,
        });
        //不是新记录，则标记其为脏记录
        if (this.TextItem.OpStatus != 1) this.TextItem.OpStatus = 2;
        this._SavePlaylist(this.Playlist[0]);
      }
    },
    SavePlaylist(obj) {
      if (obj && obj.name && obj.data) {
        const item = {
          ItemId: ZJApp.ZJUtils.uuid(),
          PlaylistId: this.PlaylistId,
          ItemType: 2,
          Sequence: 0,
          FileID: obj.data.FileID,
          FileName: obj.name,
          IsChecked: true,
          Creater: ZJApp.ZJUser.current.UserName,
          Modifier: ZJApp.ZJUser.current.UserName,
          OpStatus: 1,
        };
        this.Playlist[0].Items.push(item);
        this.FixSequence(this.Playlist[0]);

        this._SavePlaylist(this.Playlist[0]);
        setTimeout(() => {
          this.BindPlaylistAgain(this.Playlist[0]);
        }, 300);
      }
    },
    FixSequence(playlist) {
      if (playlist == null || playlist.Items == null) return;

      //修正排序号
      let sequence = 1;
      playlist.Items.forEach((x) => {
        //跳过文本语音
        if (x.ItemType == 1) return;

        //跳过已经被删除的项
        if (x.OpStatus == 3) return;

        if (x.Sequence != sequence) {
          x.Sequence = sequence;
          x.Modifier = ZJApp.ZJUser.current.UserName;
          x.ModifyTime = new Date();

          //不是新记录，则标记其为脏记录
          if (x.OpStatus != 1) x.OpStatus = 2;
        }

        sequence++;
      });
    },
    _SavePlaylist(playlist) {
      if (playlist == null) return;
      playlist.Modifier = ZJApp.ZJUser.current.UserName;
      playlist.ModifyTime = new Date();
      this.UpdatePlaylist(playlist);
    },
    UpdatePlaylist(playlist) {
      new MyApis.PlayList()
        .UpdatePlaylist(playlist)
        .then((r) => {
          r = r.data.Data;
          this.result = r;
          // this.$message({
          //   type: "success",
          //   message: r ? "保存播放列表成功！" : "保存播放列表失败",
          // });

          let newlist = playlist.Items.filter((x) => x.OpStatus == 1);
          if (newlist != null && newlist.length > 0) {
            this.AddPlaylistItem(newlist);
            newlist.forEach((x) => (x.OpStatus = 0));
          }
          let removelist = playlist.Items.filter((x) => x.OpStatus == 3);
          if (removelist != null && removelist.length > 0) {
            this.DeletePlaylistItem(removelist.map((x) => x.ItemId));
            removelist.forEach((x) => playlist.Items.pop(x));
          }
          let dirtylist = playlist.Items.filter((x) => x.OpStatus == 2);

          if (dirtylist != null && dirtylist.length > 0) {
            this.UpdatePlaylistItem(dirtylist);
            // result = api.UpdatePlaylistItem(dirtylist);
            // if (!result)
            //     throw new Exception("更新播放列表项失败");
            // else
            dirtylist.forEach((x) => (x.OpStatus = 0));
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "保存播放列表失败");
        });
    },
    AddPlaylistItem(newlist) {
      new MyApis.PlayList()
        .AddPlaylistItem(newlist)
        .then((r) => {
          r = r.data.Data;
          this.result = r;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "添加播放列表项失败");
        });
    },
    DeletePlaylistItem(itemIds) {
      new MyApis.PlayList()
        .DeletePlaylistItem(itemIds)
        .then((r) => {
          r = r.data.Data;
          this.result = r;
          console.log("删除播放列表项" + this.result);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "删除播放列表项失败");
        });
    },
    UpdatePlaylistItem(dirtylist) {
      new MyApis.PlayList()
        .UpdatePlaylistItem(dirtylist)
        .then((r) => {
          r = r.data.Data;
          this.result = r;
          console.log("更新播放列表项成功！" + this.result);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "更新播放列表项失败");
        });
    },
    //上移
    moveupClick(item) {
      const i = this.Playlist[0].Items.indexOf(item);
      if (i < 1) return;
      let tmp = this.Playlist[0].Items[i - 1];
      this.Playlist[0].Items[i - 1] = item;
      this.Playlist[0].Items[i] = tmp;
      this.FixSequence(this.Playlist[0]);
      this._SavePlaylist(this.Playlist[0]);
      setTimeout(() => {
        this.BindPlaylistAgain(this.Playlist[0]);
      }, 300);
    },
    //下载
    downloadClick(item) {
      if (item.FileUrl) document.location.href = item.FileUrl + "?d=1";
    },
    //下移
    movedownClick(item) {
      const i = this.Playlist[0].Items.indexOf(item);
      if (i >= this.Playlist[0].Items.length - 1) return;
      let tmp = this.Playlist[0].Items[i + 1];
      this.Playlist[0].Items[i + 1] = item;
      this.Playlist[0].Items[i] = tmp;
      this.FixSequence(this.Playlist[0]);
      this._SavePlaylist(this.Playlist[0]);
      setTimeout(() => {
        this.BindPlaylistAgain(this.Playlist[0]);
      }, 300);
    },
    deleteClick(index, row) {
      this.$confirm("确定要删除" + row.FileName + "吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // this.loading = true;
        // this.loadingText = '删除中...';
        row.OpStatus = 3;
        this.FixSequence(this.Playlist[0]);

        this._SavePlaylist(this.Playlist[0]);
        this.deleteFile(row);
        // setTimeout(() => {
        //   this.BindPlaylistAgain(this.Playlist[0]);
        // }, 300);
      });
    },
    deleteFile(row){
      new Apis.FileApi()
          .DeleteFile([row.FileID])
          .then((r) => {
            r = r.data.Data;
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            //this.findPlayList();
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
    },
    uploadsuccess: function (obj) {
      this.loadingAudio = false;
      this.SavePlaylist(obj);
    },
    uploadError(err) {
      this.loadingAudio = false;
      console.log(err);
    },
    uploadProgress(e) {
      this.loadingAudioText = "上传中... " + parseInt(e.percent) + "%";
    },
    //获取上传附件
    getFileList() {
      const searchInfo = {
        AssocID: this.PlaylistId,
        PageSize: 100,
        PageIndex: 1,
      };
      const that = this;
      new Apis.FileApi()
        .GetFileList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          if (r && r.FileList.length > 0 && that.audioList.length > 0) {
            that.audioList.map((item2) => {
              r.FileList.map((item1) => {
                if (item2.FileID == item1.FileID) {
                  let json = {
                    FileUrl: item1.DownloadPath,
                  };
                  Object.assign(item2, json);
                  return item2;
                }
              });
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //音乐列表选择时
    handleSelectionChange(val) {
      this.selectionRows = val;
    },
    //音乐列表全选
    toggleAllSelection() {
      this.$refs.multipleTable.toggleAllSelection();
    },
    //音乐列表反选
    toggleInverseSelection(rows) {
      let checked = this.selectionRows;
      if (rows) {
        rows.map((row) => {
          checked &&
            checked.map((item) => {
              if (row.Id !== item.Id) {
                this.$refs.multipleTable.toggleRowSelection(item, false);
                this.$refs.multipleTable.toggleRowSelection(row, true);
              } else {
                this.$refs.multipleTable.toggleRowSelection(row, false);
              }
            });
        });
        if (checked.length === 0) {
          rows.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          });
        }
      }
    },
     // 加载设备
    handleLoad() {
      this.endpoints = [];
      this.loading = true;
      this.loadingText = "加载广播设备中...";
      new MyApis.BrocastHttpApi()
        .GetSerTerminals()
        .then((r) => {
          this.onGetEndpoints(r.data.Data);
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 成功连接到媒体中心
    onConnected() {
      //this.beginGetRegions();
    },

    // beginGetEndpoints() {
    //   // 发送命令：获取终端设备数据
    //   this.mc.sendCmd(MSG.Get_End_Points);
    // },

    onError(e) {
      console.error(e);
      let msg = e && e.error && e.error.message ? e.error.message : e;
      this.$message.error("出错了: " + msg);
      this.loading = false;
    },

    // 接收到媒体中心的响应
    onRecv(e) {
      const msg = e.data;

      if (msg.isResponse()) {
        this.msgRes = msg;
        switch (msg.msgCode) {
          case MSG.Get_End_Points:
            this.onGetEndpoints(msg.getJsonData());
            break;
          case MSG.Start_TTS:
            var r = msg.getJsonData();
            if (r && r.code == "0" && r.data) {
              this.tempTaskId = r.data;
              this.$message.success("文字广播成功");
            } else {
              this.$message.error("文字广播失败");
            }
            break;
          case MSG.Start_MP3:
            var m = msg.getJsonData();
            console.log("音乐广播返回",m);
            if (m && m.code == "0" && m.data) {
              this.tempMP3TaskId = m.data;
              this.$message.success("音乐广播成功");
            } else {
              this.$message.error("音乐广播失败");
            }
            break;
          case MSG.Start_Broadcast:
            var b = msg.getJsonData();

            if (b && b.code == "0" && b.data) {
              this.tempMIC0TaskId = b.data;
              this.$message.success("人工广播成功");
            } else {
              this.$message.error("人工广播失败");
            }
            break;

          case MSG.Set_Task_Volume:
            var tv = msg.getJsonData();

            if (tv && tv.code == "0" && tv.data) {
              this.$message.success("调节音量成功");
            } else {
              this.$message.error("调节音量失败");
            }
            break;
          case MSG.Set_End_Point_Volume:
            var ev = msg.getJsonData();

            if (ev && ev.code == "0" && ev.data) {
              this.$message.success("调节音量成功");
            } else {
              this.$message.error("调节音量失败");
            }
            break;

          case MSG.MP3_Set_Mode:
            var sm = msg.getJsonData();

            if (sm && sm.code == "0" && sm.data) {
              this.$message.success("设置播放模式成功");
            } else {
              this.$message.error("设置播放模式失败");
            }
            break;
          case MSG.Broadcast_Callback:
            // eslint-disable-next-line no-redeclare
            var r = msg.getJsonData();
            if (r && r.code == "0" && r.data) {
              this.PA_Msg(r.data);
            }
            break;
        }
      }
    },
// 处理获取设备的响应
    onGetEndpoints(r) {
      if (r.length>0) {
        const list = r;
        console.log(list);
        for (let i = 0; i < list.length; i++) {
          this.endpoints.push(list[i]);
        }

        if (this.endpoints.length >= list.length) {
          this.loadingText = "加载广播设备...100%";
        }
       this.init();
      } else {
        this.loading = false;
        console.error(r && r.msg ? r.msg : "未获取到设备信息");
        this.$message.error(r && r.msg ? r.msg : "出错了: 无设备信息");
      }
    },
   
    //开始文本广播
    startTTS() {
      this.tempTaskId = null;
      if (this.selectDevices == null || this.selectDevices.length <= 0) {
        this.$message.warning("请选择广播设备");
        return;
      }
      if (this.content == "" || this.content == null) {
        this.$message.warning("请输入文本内容");
        return;
      }

      let params = {
        taskName: this.TASK_NAME_TEXT,
        text: this.content,
        sexVoice: 1,
        voiceSpeed: this.speed,
        playTimes: this.times,
        volume: this.volume,
        endpoints: this.selectDevices.map((item) => {
          return item.DeviceId;
        }),
      };
      this.sendCmd(MSG.Start_TTS, params);

      this.logInfo.ActionName = "播放文字广播";
      this.logInfo.LogMessage = `"文字广播内容：${this.content}，音量：${this.volume}，语速：${this.speed}，次数：${this.times}"`;
      this.logInfo.ModuleName = "广播系统";
      this.logInfo.PageName = "手动广播";
      this.addOperationLog();
    },
    //停止文字广播
    stopTTS() {
      var devices = this.Devices.filter((x) => x.checked);

      if (devices == null || devices.length <= 0) {
        this.$message.warning("请选择广播设备");
        return;
      }

      devices = devices.filter((x) => x.TaskName == this.TASK_NAME_TEXT);
      var taskIDs = devices.map((item) => {
        return item.TaskId;
      });
      if (taskIDs.length == 0) {
        this.$message.warning("选择的广播没有开启文字广播");
        return;
      }

      devices = this.Devices.filter(
        (x) =>
          x.TaskId != null &&
          x.TaskId != "" &&
          taskIDs.some((y) => y == x.TaskId)
      );
      taskIDs.forEach((item) => {
        this.sendCmd(MSG.Stop_TTS, { taskId: item });
      });

      var deviceNameStr = devices
        .map((x) => {
          return x.DeviceName;
        })
        .join("|");

      this.logInfo.ActionName = "停止文字广播播放";
      this.logInfo.LogMessage = `"停止文字广播播放》》 ${deviceNameStr}"`;
      this.logInfo.ModuleName = "广播系统";
      this.logInfo.PageName = "手动广播";
      this.addOperationLog();
    },
    //开始音乐广播
    startMP3() {
      this.tempMP3TaskId = null;
      if (this.selectDevices == null || this.selectDevices.length <= 0) {
        this.$message.warning("请选择广播设备");
        return;
      }
      if (this.selectionRows.length == 0) {
        this.$message.warning("请选择音乐");
        return;
      }

      let params = {
        taskName: this.TASK_NAME_MP3,
        endpoints: this.selectDevices.map((item) => {
          return item.DeviceId;
        }),
        mp3FullPaths: this.selectionRows.map((item) => {
          return item.FileUrl;
        }),
        playMode: this.playMode,
        playVolume: this.volume,
        playSecond: 3600*24,
      };

      this.sendCmd(MSG.Start_MP3, params);

      this.logInfo.ActionName = "播放音乐广播";
      this.logInfo.LogMessage = `"音乐广播内容${params.mp3FullPaths}，音量：${this.volume}，播放模式：${this.playMode}"`;
      this.logInfo.ModuleName = "广播系统";
      this.logInfo.PageName = "手动广播";
      this.addOperationLog();
    },
    //停止音乐广播
    stopMP3() {
      var devices = this.Devices.filter((x) => x.checked);

      if (devices == null || devices.length <= 0) {
        this.$message.warning("请选择广播设备");
        return;
      }

      devices = devices.filter((x) => x.TaskName == this.TASK_NAME_MP3);
      var taskIDs = devices.map((item) => {
        return item.TaskId;
      });
      if (taskIDs.length == 0) {
        this.$message.warning("选择的广播没有开启音乐广播");
        return;
      }

      devices = this.Devices.filter(
        (x) =>
          x.TaskId != null &&
          x.TaskId != "" &&
          taskIDs.some((y) => y == x.TaskId)
      );
      taskIDs.forEach((item) => {
        this.sendCmd(MSG.Stop_Server_Task, { taskId: item });
      });

      var deviceNameStr = devices
        .map((x) => {
          return x.DeviceName;
        })
        .join("|");

      this.logInfo.ActionName = "停止音乐广播播放";
      this.logInfo.LogMessage = `"停止音乐广播播放》》 ${deviceNameStr}"`;
      this.logInfo.ModuleName = "广播系统";
      this.logInfo.PageName = "手动广播";
      this.addOperationLog();
    },
    //开始人工广播
    startMIC0() {
      this.tempMIC0TaskId = null;
      if (this.selectDevices == null || this.selectDevices.length <= 0) {
        this.$message.warning("请选择广播设备");
        return;
      }

      const MIC0 =
        this.serverConfig.filter((item) => {
          return item.ItemKey == "BroadcastServerMIC0";
        }) || [];
      const micArray = (MIC0[0].ItemValue || "").split(",");

      let sendEndpoint = null; //广播发起终端
      if (micArray.length == 0) {
        this.$message.warning("请先配置桌面寻呼台");
        return;
      } else if (micArray.length > 1) {
        this.dialogVisible = true;
      } else {
        sendEndpoint = micArray[0];
        let params = {
          sendEndPoint: sendEndpoint,
          receiveEndPoints: this.selectDevices.map((item) => {
            return item.DeviceId;
          }),
        };
        this.sendCmd(MSG.Start_Broadcast, params);

        var deviceNameStr = this.selectDevices
          .map((item) => {
            return item.DeviceName;
          })
          .join("|");
        this.logInfo.ActionName = "开始人工广播";
        this.logInfo.LogMessage = `"播放人工广播 》》 ${deviceNameStr}"`;
        this.logInfo.ModuleName = "广播系统";
        this.logInfo.PageName = "手动广播";
        this.addOperationLog();
      }

      let mapM = {};
      micArray.forEach((element) => {
        mapM[element] = element;
      });
      this.mics = [];
      //不改变原数组
      let result = JSON.parse(JSON.stringify(this.DeviceList));
      result.forEach((item) => {
        if (mapM[item.DeviceId]) {
          this.mics.push(item);
        }
      });
    },
    //停止音乐广播
    stopMIC0() {
      var devices = this.Devices.filter((x) => x.checked);

      if (devices == null || devices.length <= 0) {
        this.$message.warning("请选择广播设备");
        return;
      }

      devices = devices.filter((x) => x.TaskName == this.TASK_NAME_MIC0);
      var taskIDs = devices.map((item) => {
        return item.TaskId;
      });
      if (taskIDs.length == 0) {
        this.$message.warning("选择的广播没有开启人工广播");
        return;
      }

      devices = this.Devices.filter(
        (x) =>
          x.TaskId != null &&
          x.TaskId != "" &&
          taskIDs.some((y) => y == x.TaskId)
      );
      taskIDs.forEach((item) => {
        this.sendCmd(MSG.Stop_Broadcast, { taskId: item });
      });

      var deviceNameStr = devices
        .map((x) => {
          return x.DeviceName;
        })
        .join("|");

      this.logInfo.ActionName = "停止人工广播播放";
      this.logInfo.LogMessage = `"停止人工广播播放》》 ${deviceNameStr}"`;
      this.logInfo.ModuleName = "广播系统";
      this.logInfo.PageName = "手动广播";
      this.addOperationLog();
    },
    clickCancel() {
      this.dialogVisible = false;
    },
    clickConfirm(data) {
      this.dialogVisible = false;
      let params = {
        sendEndPoint: data,
        receiveEndPoints: this.selectDevices.map((item) => {
          return item.DeviceId;
        }),
      };
      this.sendCmd(MSG.Start_Broadcast, params);

      var deviceNameStr = this.selectDevices
        .map((item) => {
          return item.DeviceName;
        })
        .join("|");
      this.logInfo.ActionName = "开始人工广播";
      this.logInfo.LogMessage = `"播放人工广播 》》 ${deviceNameStr}"`;
      this.logInfo.ModuleName = "广播系统";
      this.logInfo.PageName = "手动广播";
      this.addOperationLog();
    },
    //调节设备音量
    SetVolume() {
      var devices = this.Devices.filter((x) => x.checked);

      if (devices == null || devices.length <= 0) {
        this.$message.warning("请选择广播设备");
        return;
      }
      // 选中设备中有播放任务，则仅调节任务音量（跳过未播放的设备），否则调节设备音量。
      if (
        devices.some((x) => {
          return x.TaskId != null && x.TaskId != "";
        })
      ) {
        //调节任务音量
        var taskDevs = devices.filter(
          (x) => x.TaskId != null && x.TaskId != ""
        );
        taskDevs.forEach((item) => {
          this.sendCmd(MSG.Set_Task_Volume, {
            taskId: item.TaskId,
            volume: this.volume,
          });
        });
      } else {
        //调节设备音量
        devices.forEach((item) => {
          this.sendCmd(MSG.Set_End_Point_Volume, {
            ipv4: JSON.parse(item.JsonExtend).IP,
            volume: this.volume,
          });
        });
      }
    },
    //音乐广播 - 调整播放模式
    handleModeChange() {
      var devices = this.Devices.filter((x) => x.checked);

      if (devices == null || devices.length <= 0) {
        return;
      }
      devices = devices.filter((x) => x.TaskName == this.TASK_NAME_MP3);
      var taskIDs = devices.map((x) => {
        return x.TaskId;
      });

      if (taskIDs.length == 0) return;
      taskIDs.forEach((item) => {
        this.sendCmd(MSG.MP3_Set_Mode, {
          taskId: item,
          mode: this.playMode,
        });
      });
    },
    sendCmd(cmd, params) {
      if (this.mc.$connected) {
        this.mc.sendCmd(cmd, params);
      } else {
        this.mc.connect().then(() => {
          this.mc.sendCmd(cmd, params);
        });
      }
    },
    //响应终端信息
    PA_Msg(msg) {
      switch (msg.EventType) {
        case 1: //终端状态变化，音量或任务
          {
            var endpoint = msg.Data;
            this.UpdateDeviceInfoByEP(endpoint);
            setTimeout(() => {
              this.UpdateButtonState();
            }, 300);
          }
          break;
        case 2: //任务终端信息返回
        case 3: //任务信息编号：终端上下线、被占用状态
          {
            var task = msg.Data;
            this.UpdateDeviceInfoByTask(task);
            setTimeout(() => {
              this.UpdateButtonState();
              this.drawCanvas(task);
            }, 300);
          }
          break;

        case 4: //MP3 播放进度，播放歌曲信息
          {
            var playerInfo = msg.Data;
            console.log(playerInfo);
          }
          break;

        case 5: //任务停止
          {
            var taskId = msg.Data;

            var devices = this.Devices.filter((x) => x.TaskId == taskId);
            var ids = devices.map((item) => {
              return item.Id;
            });
            this.clearCanvas(ids);
            if (devices != null || devices.length > 0) {
              devices.forEach((dev) => {
                dev.TaskId = null;
                dev.TaskName = null;
                dev.TaskVolume = null;
                dev.TaskType = 0;
                dev.State = 0;
              });
            }

            setTimeout(() => {
              this.UpdateButtonState();
            }, 300);
          }
          break;

        case 6: //开始对讲
        case 7: //结束对讲
          break;
      }
    },
    refreshStatus() {
      this.init();
    },
    drawCanvas(src) {
      //找到播放任务中对应的canvasid
      var dests = this.Devices.filter((x) => x.TaskId == src.TaskId);
      var ids = dests.map((item) => {
        return item.Id;
      });

      ids.forEach((item) => {
        this.draw(item);
      });
    },
    draw(id) {
      var canvas = document.getElementById("canvas" + id);
      var context = canvas.getContext("2d");

      canvas.width = 350;
      canvas.height = 60;
      var WIDTH = canvas.width;
      var HEIGHT = canvas.height;
      var bufferLength = 64; // = fftSize * 0.5
      var dataArray = this.msgRes.msgData;

      //part4: 变量
      //  var barWidth = (WIDTH / dataArray.length) * 2.5; //间隔1px
      var barWidth = WIDTH / bufferLength - 1; //间隔1px
      var barHeight = 0;

      context.fillStyle = "transparent"; //透明背景
      context.fillRect(0, 0, WIDTH, HEIGHT);
      //part6: 绘画声压条
      var x = 0;
      for (var i = 0; i < bufferLength; i++) {
        var index = Math.floor(Math.random() * dataArray.length);
        var data = dataArray[index];

        var percentV = data / 255; //纵向比例
        var percentH = i / bufferLength; //横向比例

        barHeight = HEIGHT * percentV;

        //gbk,0~255
        var r = 255 * percentV; //值越大越红
        var g = 255 * percentH; //越靠右越绿
        var b = 50;

        context.fillStyle = "rgb(" + r + "," + g + "," + b + ")";
        context.fillRect(x, HEIGHT - barHeight, barWidth, barHeight);

        x += barWidth + 1; //间隔1px
      }
    },
    //清除画布
    clearCanvas(ids) {
      ids.forEach((item) => {
        var canvas = document.getElementById("canvas" + item);
        var context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height);
      });
    },
  },
  destroyed(){
    this.mc.close();
  }
};
</script>
<style lang="scss">
.panel_aside {
  padding: 0px 20px 20px 20px;
  .el-tree {
    background-color: transparent;

    border-width: 1;

    * {
      background-color: transparent;
    }
  }
  .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: rgba(61, 159, 255, 0.2);
  }
  .el-checkbox__inner {
    border-radius: 50%;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-radius: 50%;
    background: -webkit-radial-gradient(
      circle closest-side,
      #409eff 60%,
      transparent 40%
    );
  }

  .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner::after {
    border-color: transparent;
  }
}
.panel-header {
  text-align: left;
  padding: 4px 4px;
  height: 42px;
  .panel-tabs {
    float: left;
    .el-tabs__active-bar.is-top {
      left: 50%;
      width: 3rem !important;
      transform: translateX(-50%) !important;
    }
    .custom-tabs.el-tabs--top .el-tabs__active-bar {
      bottom: 1rem;
      height: 0.5rem;
      background-color: #409eff;
      border-radius: 0.5rem;
      box-shadow: 0 -0.3rem 0.5rem rgba(64, 158, 255, 0.7);
    }

    .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 0rem;
    }
    .custom-tabs.el-tabs--top .el-tabs__item.is-active {
      color: #2bc5ff;
      font-size: 1.8rem;
      font-weight: bold;
    }
  }

  .panel-header-button-left {
    background-color: transparent;
  }
  .panel-header-button-left:hover {
    background: rgba(61, 159, 255, 0.2);
  }
  .panel-header-button-right {
    background-color: transparent;
    border-color: rgb(217, 72, 77);
    color: rgb(217, 72, 77);
  }
  .panel-header-button-right:hover {
    background: rgba(217, 72, 77, 0.2);
  }
}
.main-content {
  padding: 0;
  .main-card-checked {
    border: 1px solid rgb(61, 159, 255);
  }
  .main-card-disabled {
    pointer-events: none;
  }
  .main-content-card {
    position: relative;
    height: 8rem;
    padding: 0.7rem;
    background-color: rgba(61, 159, 255, 0.2);
    margin: 5px;
    cursor: pointer;
    .card-close {
      float: right;
      margin-top: -0.5rem;
      margin-right: -0.5rem;
    }
    .card-device {
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      white-space: nowrap;
    }
    .el-icon-my-broadcast_e {
      background: url("../../../../../../assets/broadcast_e.png") center
        no-repeat;
      background-size: cover;
    }
    .el-icon-my-broadcast_e:before {
      content: "\5e7f";
      font-size: 16px;
      visibility: hidden;
    }

    .el-icon-my-broadcast_u {
      background: url("../../../../../../assets/broadcast_u.png") center
        no-repeat;
      background-size: cover;
    }
    .el-icon-my-broadcast_u:before {
      content: "qu";
      font-size: 14px;
      visibility: hidden;
    }

    .main-content-card-content {
      margin-left: 24px;
      margin-top: 4px;
    }
  }
}
.el-icon-my-play {
  background: url("../../../../../../assets/play.png") center no-repeat;
  background-size: cover;
}
.el-icon-my-play:before {
  content: "\5f00";
  font-size: 12px;
  visibility: hidden;
}
.el-icon-my-pause {
  background: url("../../../../../../assets/pause.png") center no-repeat;
  background-size: cover;
}
.el-icon-my-pause:before {
  content: "\6682";
  font-size: 12px;
  visibility: hidden;
}
// .vulume_adjust {

// }
.el-tooltip__popper.is-dark {
  background: rgb(0, 35, 69) !important;
}
.el-tooltip__popper.popper__arrow {
  border-width: 0;
  background-color: #3d9fff;
  border-color: #3d9fff;
}
.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
  border-top-color: #3d9fff;
}
.table-music /deep/.el-table__body-wrapper {
  height: 100% !important;
}
.table-music {
  .el-checkbox__inner {
    border-radius: 50%;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-radius: 50%;
    background: -webkit-radial-gradient(
      circle closest-side,
      #409eff 60%,
      transparent 40%
    );
  }

  .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner::after {
    border-color: transparent;
  }
}
.custom-tree-node {
  .el-icon-my-broadcast_e {
    background: url("../../../../../../assets/broadcast_u.png") center no-repeat;
    background-size: cover;
    margin-left: 5px;
  }
  .el-icon-my-broadcast_e:before {
    content: "qu";
    font-size: 12px;
    visibility: hidden;
  }
}
.el-checkbox.is-checked + .custom-tree-node {
  .el-icon-my-broadcast_e {
    background: url("../../../../../../assets/broadcast_e.png") center no-repeat;
    background-size: cover;
    margin-left: 5px;
  }
  .el-icon-my-broadcast_e:before {
    content: "\5e7f";
    font-size: 15px;
    visibility: hidden;
  }
  .custom-tree-node-label {
    color: rgb(32, 149, 226);
  }
}
.panel-right-font {
  color: #2bc5ff;
  font-size: 1.8rem;
}
.panel-right-mode {
  margin-top: 10px;
  text-align: right;
}
.panel-right {
  .panel-right-speed {
    margin-right: 2px;
  }
  .panel-right-times {
    margin-left: 10px;
    margin-right: 2px;
  }
}

.canvas {
  // position: fixed;
  left: 10;
  top: 10;
  width: 100%;
  height: 66%;
}
</style>
